// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-sidebar {
  padding-bottom: 1rem;
  margin-bottom: 0.5rem;
}
.settings-sidebar:last-child {
  padding-bottom: 0;
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .settings-sidebar {
    display: none;
  }
}
.settings-sidebar:last-child {
  border-bottom: none;
}
@media (max-width: 768px) {
  .settings-sidebar:last-child {
    border-bottom: 1px solid var(--black1);
  }
}
.settings-sidebar-wrapper select {
  display: none;
  width: 100%;
  margin-bottom: 1.5rem;
}
@media (max-width: 768px) {
  .settings-sidebar-wrapper {
    display: flex;
    width: 100%;
  }
  .settings-sidebar-wrapper select {
    display: flex;
  }
}
.settings-sidebar-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: var(--black4);
  padding: 0.5rem 0.75rem;
}
.settings-sidebar-body {
  display: flex;
  flex-direction: column;
  line-height: 1rem;
}
.settings-sidebar-body a {
  display: flex;
  padding: 0.5rem 0.75rem;
  color: var(--black5) !important;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  align-items: center;
}
.settings-sidebar-body a svg {
  margin-right: 0.75rem;
}
.settings-sidebar-body a:hover {
  text-decoration: none;
  color: var(--black9) !important;
}
.settings-sidebar-body a.active {
  background: var(--black1);
  color: var(--black9) !important;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
}
.settings-sidebar-body a.active svg * {
  stroke: var(--purple6);
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/layouts/settings/sidebar/index.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,qBAAA;AACF;AACE;EACE,iBAAA;EACA,gBAAA;AACJ;AAEE;EATF;IAUI,aAAA;EACF;AACF;AACE;EAIE,mBAAA;AAFJ;AADI;EADF;IAEI,sCAAA;EAIJ;AACF;AAEI;EACE,aAAA;EACA,WAAA;EACA,qBAAA;AAAN;AAGI;EARF;IASI,aAAA;IACA,WAAA;EAAJ;EACI;IACE,aAAA;EACN;AACF;AAGE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,uBAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAFJ;AAII;EACE,aAAA;EACA,uBAAA;EACA,+BAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAFN;AAIM;EACE,qBAAA;AAFR;AAKM;EACE,qBAAA;EACA,+BAAA;AAHR;AAMM;EACE,yBAAA;EACA,+BAAA;EACA,qBAAA;EACA,uBAAA;AAJR;AAMQ;EACE,sBAAA;AAJV","sourcesContent":[".settings-sidebar {\n  padding-bottom: 1rem;\n  margin-bottom: .5rem;\n\n  &:last-child {\n    padding-bottom: 0;\n    margin-bottom: 0;\n  }\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n\n  &:last-child {\n    @media (max-width: 768px) {\n      border-bottom: 1px solid var(--black1);\n    }\n    border-bottom: none;\n  }\n\n  &-wrapper {\n\n    select {\n      display: none;\n      width: 100%;\n      margin-bottom: 1.5rem;\n    }\n\n    @media (max-width: 768px) {\n      display: flex;\n      width: 100%;\n      select {\n        display: flex;\n      }\n    }\n  }\n\n  &-title {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 13px;\n    line-height: 16px;\n    color: var(--black4);\n    padding: .5rem .75rem;\n  }\n\n  &-body {\n    display: flex;\n    flex-direction: column;\n    line-height: 1rem;\n\n    a {\n      display: flex;\n      padding: .5rem .75rem;\n      color: var(--black5) !important;\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 17px;\n      align-items: center;\n\n      svg {\n        margin-right: .75rem;\n      }\n\n      &:hover {\n        text-decoration: none;\n        color: var(--black9) !important;\n      }\n\n      &.active {\n        background: var(--black1);\n        color: var(--black9) !important;\n        border-radius: .5rem;\n        padding: .5rem .75rem;\n\n        svg * {\n          stroke: var(--purple6);\n        }\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
